import { BASE_ELEMENT_IDS } from "../ui/BaseDOM";
import { injectable } from "inversify";
import { paddy } from "../helpers";

@injectable()
export default class LoadingScreen {
	protected _wrapper: HTMLElement;

	private _logo: HTMLElement;
	private _dots: HTMLElement;
	protected _gameLogo: HTMLElement;
	private _bonusGamesWrapper: HTMLElement;

	private _steps: number = 0;
	private _dotsArray: Array<HTMLElement> = [];
	protected _dotsColors: Array<string> = [
		'#ffffff', '#cdebff', '#8fc9ef', '#66a8d3', '#4798cc', '#2990c9', '#1876b3'
	]

	private _planetInterval: any;

	create() {
		let parent = document.getElementById(BASE_ELEMENT_IDS.LOADING);

		this._wrapper = parent;
		// this._wrapper = document.createElement("div");
		// this._wrapper.id = BASE_ELEMENT_IDS.LOADING;
		// this._wrapper.classList.add("mx-loading-wrapper");
		// parent.appendChild(this._wrapper);

		let gameLogo = document.createElement("div");
		gameLogo.classList.add("mx-loading-game-logo");
		parent.appendChild(gameLogo);
		this._gameLogo = gameLogo;

		const bonusGamesContainer = document.createElement("div");
		bonusGamesContainer.classList.add("mx-loading-bonus-games");
		parent.appendChild(bonusGamesContainer);
		this._bonusGamesWrapper = bonusGamesContainer;

		let logo = document.createElement("div");
		logo.classList.add("mx-loading-logo");
		parent.appendChild(logo);
		this._logo = logo;

		let cont = document.createElement("div");
		cont.classList.add("mx-loading-container");
		cont.id = BASE_ELEMENT_IDS.LOADING_CONTAINER;
		parent.appendChild(cont);
		// this._wrapper.appendChild(cont);

		let dots = document.createElement("div");
		dots.classList.add("mx-loading-dots");
		cont.appendChild(dots);
		this._dots = dots;

		for (let i = 0; i < 7; i++) {
			let dot = document.createElement("div");
			dot.classList.add("mx-loading-dot");
			dots.appendChild(dot);
			this._dotsArray.push(dot);
		}

		let planet = document.createElement("div");
		planet.classList.add("logo-planet-container");
		planet.innerHTML =
			'<svg class="logo-planet"><use xlink:href="#icon-logo_00001"></use></svg>';
		this._logo.appendChild(planet);
	}

	addBonusGame(iconClass: string) {
		let bonusGameLogo = document.createElement("div");
		bonusGameLogo.classList.add(iconClass);
		this._bonusGamesWrapper.appendChild(bonusGameLogo);
	}

	start() {
		this._gameLogo.style.opacity = "1";
		this._logo.style.opacity = "1";
		this._dots.style.opacity = "1";
		this._bonusGamesWrapper.style.opacity = "1";

		let i = 1;
		this._planetInterval = setInterval(() => {
			let path = "#icon-logo_000" + paddy((++i % 50) + 1, 2);
			$(".logo-planet").children()[0].setAttribute("xlink:href", path);
		}, 75);

		this._bump(0);
	}

  updateMultiple(loaderId: string, progress: number, weight: number){
	//LoaderV2 compatibility layer
		if(loaderId === 'framework'){
			this.update(progress)
		}
	}

	update(perc: number): void {
		let unit = 100 / 7;
		let step = Math.floor(perc / unit);

		if (this._steps < step) {
			for (let i = this._steps; i < step; i++) {
				if (i == 0) continue;
				this._bump(i);
			}

			this._steps = step;
		}
	}

	_bump(index: number) {
		let dot = this._dotsArray[index];
		dot.style["animation-name"] = "dot-bump";
		dot.style["backgroundColor"] = this._dotsColors[index];
	}

	hide():  false | Promise<void>  {
		// return new Promise(() => {});

		return new Promise<void>((res) => {
			setTimeout(() => {
				this._wrapper.style.opacity = "0";

				setTimeout(() => {
					this._wrapper.style.display = "none";
					clearInterval(this._planetInterval);
					res();
				}, 600);
			}, 1000);
		});
	}
}
